module.exports = __webpack_public_path__ + "img/834.99688369.png";